'use strict'
import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';


let cancel ,promiseArr = {}
const CancelToken = axios.CancelToken;
axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {

    return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});
function checkStatus (response) {
    if (response && (response.status === 200 || response.status === 304 ||
            response.status === 400)) {
        return response
    }
    return {
        status: -404,
        msg: '网络异常'
    }
}

function checkCode (res) {
    if (res.status === -404) {
        Vue.prototype.$message.error('网络异常');
    }
    if (res.data && (!res.data.success)) {
        let resText;
        if(res.data.message){
            resText = res.data.message;
        }else{
            resText = res.data.comment;
        }
        // Vue.prototype.$message.error(resText);
    }
    return res
}
axios.defaults.withCredentials = true;
// axios.defaults.baseURL = 'http://app.kaopujinfu.com'
axios.defaults.baseURL = 'http://article.kaopujinfu.com'
// axios.defaults.baseURL = 'http://console.kaopujinfu.com'
// axios.defaults.baseURL = 'http://10.28.0.236:8020'
// axios.defaults.baseURL = 'http://10.28.0.236:8070'
// axios.defaults.baseURL = 'http://10.28.0.236:8060'
//设置默认请求头
axios.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
axios.defaults.timeout = 5000

export default {
    post (url, data) {  //  post
        return axios({
            method: 'post',
            url,
            data: qs.stringify(data),
            cancelToken: new CancelToken(c => {
                cancel = c
            })
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).then(
            (res) => {
                return checkCode(res)
            }
        )
    },
    get (url, params) {  
        return axios({
            method: 'get',
            url,
            params,
            cancelToken: new CancelToken(c => {
                cancel = c
            })
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).then(
            (res) => {
                return checkCode(res)
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/tool/http.js